// extracted by mini-css-extract-plugin
export var PageLoader = "PageLoader-module--PageLoader--V-W4w";
export var Wrap = "PageLoader-module--Wrap--f6fbg";
export var Icon = "PageLoader-module--Icon--FxEbR";
export var LogoAnimate = "PageLoader-module--LogoAnimate--FuUCJ";
export var Logo = "PageLoader-module--Logo--lxfO5";
export var arrowLeft = "PageLoader-module--arrowLeft--axnjl";
export var arrowRight = "PageLoader-module--arrowRight--N5FkS";